export const buildAgentPreview = (form, t) => {
  const responseLengthLabels = {
    short: t('CAPTAIN_EXPERIENCE.SCRIPT.RESPONSE_LENGTH_SHORT'),
    medium: t('CAPTAIN_EXPERIENCE.SCRIPT.RESPONSE_LENGTH_MEDIUM'),
    complete: t('CAPTAIN_EXPERIENCE.SCRIPT.RESPONSE_LENGTH_COMPLETE'),
  };
  const responseLength =
    responseLengthLabels[form.responseLength] || responseLengthLabels.short;

  return t('CAPTAIN_EXPERIENCE.SCRIPT.PREVIEW_RESPONSE', {
    name: form.name || t('CAPTAIN_EXPERIENCE.SCRIPT.DEFAULT_AGENT_ALIAS'),
    product:
      form.productName || t('CAPTAIN_EXPERIENCE.SCRIPT.DEFAULT_PRODUCT_NAME'),
    responseLength: responseLength.toLowerCase(),
    unknownResponse: form.unknownResponse.toLowerCase(),
  });
};
